import { RoleList } from "./state";

export function initUserRoleAction(roleList:RoleList[]){
    return {
        type: "@@UserRole/initUserRoleAction" as const,
        roleList
    }
}




export type UserRoleAction =
ReturnType<typeof initUserRoleAction>